import { createFileRoute, redirect } from '@tanstack/react-router';

/** Marketing page lives on the landing site. */
export const Route = createFileRoute('/practice')({
  beforeLoad: () => {
    throw redirect({
      href: 'https://greetai.co/extension',
    });
  },
  component: () => null,
});
